import React from 'react'
import { NavLink } from 'react-router-dom'
import { navigationProps } from '../propTypes'

import './HeaderNav.css'

const HeaderNav = ({ navigation }) => (
    <ul className="header-nav__nav">
        {navigation.map((navItem, i) => {
            const isExternal = navItem.link.startsWith('http')

            return (
                <li key={i}>
                    {isExternal ? (
                        <a
                            href={navItem.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="header-nav__link"
                        >
                            {navItem.title}
                        </a>
                    ) : (
                        <NavLink
                            to={navItem.link}
                            className="header-nav__link"
                            activeClassName="is-active"
                        >
                            {navItem.title}
                        </NavLink>
                    )}
                </li>
            )
        })}
    </ul>
)

HeaderNav.propTypes = {
    navigation: navigationProps
}

export { HeaderNav }
